import React from "react";
import ReactWordcloud from "react-wordcloud";

const WordCloudComp = ({ data }) => {
  console.log(data,'ddd')
  const options = {
    rotations: 2,
    rotationAngles: [0],
    fontSizes: [20, 30],
  };
  const words = Object.keys(data??[])?.map((key) => ({
    text: key,
    value: data[key],
  }));
  if (!words || !options || !data ) return null;
  return <ReactWordcloud words={words ?? []} options={options} />;
};

export default WordCloudComp;
